// let  AppId = 'Smart_adult_test';
let  AppId = 'Smart_adult';
let  AppSecret = 'RTyDIkL3zjQhX57j^JwbRUMOP07^@0eo';


export {AppId,AppSecret};